import React from 'react';
import { Typography } from "../../ecosystem";

const NotManagingMsg = ({
    message,
}) => {

    return (
        <Typography
            type="body-01"
            color="$color-seconday-a2"
            tag="div"
        >
            You are not managing anyone’s account.
        </Typography>
    );
}

export default NotManagingMsg;
